import {
  Box,
  Breadcrumbs,
  Container,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
import { getAllCompanies } from "../../api/user/User";
import CompanyAccessLevelListTable from "../../components/dashboard/admin/CompanyAccessLevelListTable";
import useSettings from "../../hooks/useSettings";
import ChevronRightIcon from "../../icons/ChevronRight";

const CompanyAccessLevel = () => {
  const { settings } = useSettings();
  const [companies, setCompanies] = useState(null);
  const [nameSearchValue, setNameSearchValue] = useState("");

  useEffect(() => {
    getCompanies();
  }, [nameSearchValue]);

  const getCompanies = async () => {
    const res = await getAllCompanies(nameSearchValue);
    if (res.data.data) {
      setCompanies(res.data.data);
    }
  };

  const searchHandler = (e) => {
    e.preventDefault();
    setNameSearchValue(e.target.value);
  };

  return (
    <>
      <Helmet>
        <title>Dashboard: Company - Access Level Setting</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
        }}
      >
        <Container maxWidth={settings.compact ? "xl" : false}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={3}
          >
            <Grid item>
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<ChevronRightIcon fontSize="small" />}
                sx={{ mt: 1 }}
              >
                <Link
                  color="textSecondary"
                  component={RouterLink}
                  to="/"
                  variant="breadCrumbText"
                >
                  Dashboard
                </Link>
                <Link
                  color="textSecondary"
                  component={RouterLink}
                  to="/dashboard/admin-setting/view-all-credentials"
                  variant="breadCrumbText"
                >
                  Admin Settings
                </Link>
              </Breadcrumbs>
              <Typography color="textPrimary" variant="dashboardHeading">
                Company - Access Level Setting
              </Typography>
              <Box
                sx={{
                  mt: 0.5,
                }}
              >
                <Typography
                  color="textPrimary"
                  component="span"
                  variant="dashboardInfo"
                >
                  Total Companies:
                </Typography>
                <Typography
                  component="span"
                  variant="dashboardInfo"
                  sx={{
                    color: "#00000E",
                    pl: 1,
                  }}
                >
                  {companies?.company_count || 0}
                </Typography>

                <Typography
                  color="textPrimary"
                  component="span"
                  variant="dashboardInfo"
                  sx={{ ml: 2 }}
                >
                  Paid:
                </Typography>
                <Typography
                  component="span"
                  variant="dashboardInfo"
                  sx={{
                    color: "success.main",
                    pl: 1,
                  }}
                >
                  {companies?.company_paid_count || 0}
                </Typography>

                <Typography
                  color="textPrimary"
                  component="span"
                  variant="dashboardInfo"
                  sx={{ ml: 2 }}
                >
                  Trial:
                </Typography>
                <Typography
                  component="span"
                  variant="dashboardInfo"
                  sx={{
                    color: "success.main",
                    pl: 1,
                  }}
                >
                  {companies?.company_trial_count || 0}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <CompanyAccessLevelListTable
              companies={companies?.company_data}
              getCompanies={getCompanies}
              nameSearchValue={nameSearchValue}
              searchHandler={searchHandler}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default CompanyAccessLevel;
